export default {
      id: "icon-menu-close-usage",
      viewBox: "0 0 26.953 26.953",
      url: __webpack_public_path__ + "img/icons.c8a27ec6.svg#icon-menu-close",
      toString: function () {
        return this.url;
      }
    }